import axios from '../../plugins/axios';

export const updateServiceNotification = ({}, { data, serviceId, notificationId }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  
  return axios.put(`/api/service/${serviceId}/notification/${notificationId}`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
};

export const createServiceNotification = ({}, { data, serviceId }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }

  return axios.post(`/api/service/${serviceId}/notification`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
}

export const deleteServiceNotification = ({}, { notificationId, serviceId }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }

  return axios.delete(`/api/service/${serviceId}/notification/${notificationId}`, config)
    .then((response) => response )
    .catch((error) => error.response );
}
